module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/RE-d78b27c9e803015f84f0a7f8b715a20e.png";